// @ts-check
import {
  Box,
  Flex,
  SkeletonBox,
  SkeletonText,
  SkeletonTitle,
} from '~/design-system';

export default function ImportOptionsSkeleton() {
  return (
    <Box>
      <Box sx={{ margin: 'auto', width: '330px', textAlign: 'left' }}>
        <ReadyCheckboxFieldSkeleton />
        <ReadyCheckboxFieldSkeleton />
        <ReadyCheckboxFieldSkeleton />
        <ReadyCheckboxFieldSkeleton />
      </Box>
    </Box>
  );
}

function ReadyCheckboxFieldSkeleton() {
  return (
    <Flex align="center" sx={{ height: 50 }}>
      <Box sx={{ marginRight: 4 }}>
        <SkeletonBox height={20} width={20} />
      </Box>
      <Box
        sx={{
          marginRight: 3,
          textAlign: 'right',
          width: '65px',
          height: '36px',
          display: 'table',
        }}
      >
        <SkeletonTitle
          sx={{ display: 'table-cell', verticalAlign: 'middle' }}
          variant="small"
        />
      </Box>
      <Box sx={{ width: '300px', height: '36px', display: 'table' }}>
        <SkeletonText
          variant="smallest"
          sx={{ display: 'table-cell', verticalAlign: 'middle' }}
        />
      </Box>
    </Flex>
  );
}
